module.exports = __webpack_public_path__ + "static/media/number1.1d7bdb96.svg";